module.exports = __webpack_public_path__ + "img/1912_Frauen-in-der-Styria.f5d26617.jpg";